var _svg;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLocation = ({
  className = '',
  ...props
}) => /*#__PURE__*/React.createElement("span", _extends({
  className: `-svg-file-Location Icon ${className}`
}, props), _svg || (_svg = /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  viewBox: "4 2 16 20"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 2a8 8 0 0 0-8 8c0 5 8 12 8 12s8-7 8-12a8 8 0 0 0-8-8m0 17.27C9.28 16.59 6 12.54 6 10a6 6 0 0 1 12 0c0 2.53-3.28 6.59-6 9.27"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 7a3 3 0 0 0-.5 0 3 3 0 0 0 .5 6 3 3 0 0 0 .5 0 3 3 0 0 0-.5-6m.81 3.58a1 1 0 0 1-.64.41H12a1 1 0 0 1-.81-1.58 1 1 0 0 1 .64-.41H12a1 1 0 0 1 .81 1.58"
}))));
export default SvgLocation;